import { render, staticRenderFns } from "./AddEditStorageModal.vue?vue&type=template&id=f0c6a3bc&scoped=true"
import script from "./AddEditStorageModal.vue?vue&type=script&lang=js"
export * from "./AddEditStorageModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0c6a3bc",
  null
  
)

export default component.exports